<template>
  <div class="d-flex justify-content-center align-items-center gradient-bg">
    <div class="py-3 footer-color">
      <div>
        <span>
          {{ copyright }} © Copyright
        </span>
        <span>
          <router-link :to="{ path: '/' }" class="copyright-link">AMBPOKER.CC</router-link>
        </span>
        <span> All rights Reserved.</span>
      </div>
      <div>
        Powered by
      </div>
      <div class="w-100 mx-auto">
        <img
          class="footer-ambgame-logo mt-2"
          src="../assets/logo/amb-logo-full.png"
          alt="logo ambgame"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'webFooter',
  data() {
    return {
      copyright: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.gradient-bg {
  background: rgb(51, 58, 68);
  background: -moz-linear-gradient(
    0deg,
    rgba(51, 58, 68, 1) 0%,
    rgba(51, 58, 68, 0.5) 90%,
    rgba(51, 58, 68, 0) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(51, 58, 68, 1) 0%,
    rgba(51, 58, 68, 0.5) 90%,
    rgba(51, 58, 68, 0) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(51, 58, 68, 1) 0%,
    rgba(51, 58, 68, 0.5) 90%,
    rgba(51, 58, 68, 0) 100%
  );
  filter: progid:DXImageTransform.
  Microsoft.gradient(startColorstr="#333a44", endColorstr="#333a44", GradientType=1);
}

@media only screen and (max-width: 768px) {
  .footer-color {
    font-size: 0.8em !important;
  }
  .footer-ambgame-logo {
    width: 35% !important;
  }
}
.footer-ambgame-logo {
  width: 40%;
}
.footer-color {
  color: #dfe4ea;
  font-size: 1em;
}
.copyright-link {
  color: #64bb46;
}
</style>
